import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@beef/legacy-ui-kit';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var LegalWithTooltip = function LegalWithTooltip(_ref) {
  var userAgreementText = _ref.userAgreementText,
    termsOfUse = _ref.termsOfUse,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('termOfUse', className),
    "data-t-id": "legacy-LegalWithTooltip"
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: userAgreementText
    }
  }), /*#__PURE__*/React.createElement(Tooltip, {
    contentPosition: "top"
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: termsOfUse
    },
    "data-t-id": "legacy-LegalWithTooltip"
  })));
};
LegalWithTooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  userAgreementText: PropTypes.string,
  termsOfUse: PropTypes.string,
  className: PropTypes.string
} : {};
export default LegalWithTooltip;